import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'libero-opf-fee-confirm-modal',
  templateUrl: './opf-fee-confirm-modal.component.html',
  styleUrl: './opf-fee-confirm-modal.component.scss',
  standalone: false
})
export class OpfFeeConfirmModalComponent {
  @Input() public show: boolean | null = null;
  @Output() public continueBtnClick = new EventEmitter<void>();
  @Output() public backBtnClick = new EventEmitter<void>();

  public onContinueBtnClick(): void {
    this.continueBtnClick.emit();
  }

  public onBackBtnClick(): void {
    this.backBtnClick.emit();
  }
}
